module.exports = {
  background: true,
  accordionTitle: 'Registering with United Cargo',
  rows: [
    {
      title: 'How can I arrange a shipment via United Cargo?',
      content: {
        regions: [
          {
            regions: [],
            fragments: [
              {
                presentation: {
                  view: 'BodyText'
                },
                content: {
                  bodyCopy:
                    '<p>Prior to acceptance, all shipments must meet specific Transportation Security Administration (TSA) Security Requirements:</p><br><br><ul><li><p>All shipments are subject to inspection.</p></li><li><p>All customers tendering shipments must have one form of government-issued photo ID or two other forms of ID, one of which must be issued by a government authority.</p></li><li><p>A complete and accurate commodity description, either on the air waybill or on an attached manifest, must be provided at time of tender.</p></li></ul><br><p>For most shipments, anyone wishing to tender cargo to us in the United States must meet one of the two requirements listed below. These requirements are regulated by the TSA. For more information on these regulations, please visit the <a href="http://www.united.com">TSA website</a>.</p><br><h3>1. Known Shipper</h3><br><p>A Known Shipper is an individual or entity wishing to tender their own goods for air transportation on a passenger air carrier that has gone through an approval process mandated by the TSA.</p><br><p>If you are not already a Known Shipper, please fill out the Known Shipper Request form. This form is required to start the process of becoming a Known Shipper with United. We will verify your information through the TSA database. If a site inspection is required there will be a non-refundable minimum fee of $75.00. This fee is mileage based and may be higher. For customers who require a site visit, there will be an initial site visit and recurrent site visits are required in order to remain on the Known Shipper list.</p><br><h3>2. Indirect Air Carrier (IAC)</h3><br><p>An Indirect Air Carrier (IAC) means any person or entity within the United States not in possession of an FAA air carrier operating certificate, that ships cargo belonging to any other person or entity. An IAC undertakes to engage indirectly in air transportation of property and uses for all or any part of such transportation the services of a passenger air carrier. Each Indirect Air Carrier must adopt and carry out a security program that meets TSA requirements.</p><br><p>For more information concerning the regulations and procedures for an IAC or to register with the TSA, visit the <a href="http://www.united.com">TSA website</a>.</p>'
                },
                metadata: {
                  contentModel: 'generalContent'
                },
                id: '436c461b-8cfa-4d46-8531-5a91c4b1343d',
                name: 'BodyText'
              }
            ],
            id: '436c461b-8cfa-4d46-8531-5a9',
            name: 'main',
            extendedProperties: {
              regionType: 'region.row',
              regionName: 'main'
            }
          }
        ]
      }
    },
    {
      title:
        "I would like to register all my company's offices as users of unitedcargo.com. How do I do this?",
      content: {
        regions: [
          {
            regions: [],
            fragments: [
              {
                presentation: {
                  view: 'ContainerSpecs'
                },
                content: {
                  headline: 'E – IATA Rate Class 9',
                  description: 'This is best used for X type of shipment.',
                  image: {
                    content: {
                      src: '/container-specs-image.svg',
                      alt: 'E – IATA Rate Class 9'
                    }
                  },
                  imageMobile: {
                    content: {
                      src: '/container-specs-image.svg',
                      alt: 'E – IATA Rate Class 9'
                    }
                  },
                  list: [
                    {
                      key: '<p>Internal Capacity</p>',
                      value: '<p>236 cu. ft. / 6.68 m³</p>'
                    },
                    {
                      key: '<p>Maximum Gross Weight</p>',
                      value: '<p>10,200 lbs. / 6,033 kg</p>'
                    },
                    {
                      key: '<p>Max external dimensions (l x w x h)</p>',
                      value:
                        '<p>125” x 88” x 64” 317.5 cm x 223.5 cm x 162.6 cm</p>'
                    },
                    {
                      key: '<p>Tare Weight</p>',
                      value: '<p>2,675 lbs. / 1,213 kg</p>'
                    },
                    {
                      key: '<p>Container Prefix</p>',
                      value: '<p>RAP</p>'
                    },
                    {
                      key: '<p>Aircraft Accepted For</p>',
                      value: '<p>767, 777, 787</p>'
                    },
                    {
                      key: '<p>Temperature Range</p>',
                      value: '<p>+39.2 to +77 °F (+4 to 25 °C)</p>'
                    },
                    {
                      key: '<p>Max Main Loading Space</p>',
                      value:
                        '<p>97.5” x 82” x 51” 247.7 cm x 208.3 cm x 129.5 cm</p>'
                    }
                  ]
                },
                metadata: {
                  contentModel: 'generalContent'
                },
                id: '436c461b-8cfa-4d46-8531-5a91c4b1343d-8765',
                name: 'ContainerSpecs'
              }
            ],
            id: '436c461b-8cfa-4d46-8531-5a9ugjhg',
            name: 'main',
            extendedProperties: {
              regionType: 'region.row',
              regionName: 'main'
            }
          }
        ]
      }
    },
    {
      title:
        "I'm a registered user and my company moved to a new location. How do I update our company information?",
      content: {
        regions: [
          {
            regions: [],
            fragments: [
              {
                presentation: {
                  view: 'BodyText'
                },
                content: {
                  bodyCopy:
                    '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Eros in cursus turpis massa tincidunt dui. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat. Nunc scelerisque viverra mauris in aliquam. Cras ornare arcu dui vivamus arcu felis. Quis ipsum suspendisse ultrices gravida dictum fusce. Magna fermentum iaculis eu non diam phasellus vestibulum lorem. Magna fringilla urna porttitor rhoncus dolor purus. Eget nunc lobortis mattis aliquam. Aliquet sagittis id consectetur purus ut. Ut sem nulla pharetra diam sit amet nisl suscipit. Dolor magna eget est lorem. Vehicula ipsum a arcu cursus vitae congue mauris rhoncus.</p><br><p>Morbi leo urna molestie at elementum eu facilisis. Dolor sit amet consectetur adipiscing elit duis. Tempor id eu nisl nunc mi ipsum faucibus. Consectetur a erat nam at lectus urna duis convallis. Ut aliquam purus sit amet luctus venenatis lectus magna. Vel pharetra vel turpis nunc eget lorem dolor. Dignissim suspendisse in est ante in nibh mauris cursus mattis. Id velit ut tortor pretium viverra suspendisse potenti nullam ac. Nulla facilisi cras fermentum odio. In nibh mauris cursus mattis molestie a iaculis. Sed risus ultricies tristique nulla aliquet enim tortor at. Lectus sit amet est placerat in egestas erat imperdiet. Mattis molestie a iaculis at erat. Sit amet mattis vulputate enim nulla.</p><br><p>Nisl nunc mi ipsum faucibus vitae aliquet nec. Metus dictum at tempor commodo ullamcorper. Diam maecenas ultricies mi eget mauris pharetra. Nisl condimentum id venenatis a condimentum vitae sapien. Commodo elit at imperdiet dui accumsan sit. Placerat in egestas erat imperdiet sed. Consequat nisl vel pretium lectus quam id leo in vitae. Eget mauris pharetra et ultrices neque ornare. Elementum nisi quis eleifend quam. Ac tincidunt vitae semper quis lectus nulla at volutpat diam. Aliquam sem fringilla ut morbi tincidunt augue interdum. Elementum nibh tellus molestie nunc non blandit massa. Ipsum faucibus vitae aliquet nec ullamcorper sit.</p>'
                },
                metadata: {
                  contentModel: 'generalContent'
                },
                id: '436c461b-8cfa-4d46-8531-sdfsdasf',
                name: 'BodyText'
              }
            ],
            id: '436c461b-8cfa-4d46-sdfsdfs-5a9',
            name: 'main',
            extendedProperties: {
              regionType: 'region.row',
              regionName: 'main'
            }
          }
        ]
      }
    }
  ]
};
